<script lang="ts" setup>
import { ref } from "vue";
import {
  TirPmModal,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";

/**Открыто ли окно */
const visible = ref(false);
/**Колбэк для выхода */
const leaveCallback = ref<Function>();

/**Переключение видимости окна */
const toggle = (_visible: boolean, callback?: Function) => {
  visible.value = _visible;
  leaveCallback.value = _visible ? callback : undefined;
};
/**Подтверждение выхода */
const confirmLeave = () => {
  leaveCallback.value?.();
  toggle(false);
};

/**Код для использования по ref */
defineExpose({ toggle });
</script>
<template>
  <TirPmModal
    class="task-parameters-leave"
    title="Выйти сейчас?"
    :is-with-back="false"
    :is-visible="visible"
    @close="toggle(false)"
  >
    <template #content>
      <span class="task-parameters-leave_content"> Если выйти сейчас, данные не сохранятся </span>
    </template>
    <template #footer>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.PrimaryState"
        @click="toggle(false)"
      >
        Вернуться
      </TirPmButton>
      <TirPmButton
        :size="TirPmButtonSizeEnum.Regular"
        :variant="TirPmButtonVariantEnum.LinkState"
        @click="confirmLeave"
      >
        Выйти
      </TirPmButton>
    </template>
  </TirPmModal>
</template>
<style lang="scss" scoped>
.task-parameters-leave {
  &_content {
    font-size: 0.875rem;
    color: var(--text-secondary);
  }
}
</style>
